import { render, staticRenderFns } from "./GridNavigation.vue?vue&type=template&id=2fee8f6c&"
import script from "./GridNavigation.vue?vue&type=script&lang=ts&"
export * from "./GridNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports